// extracted by mini-css-extract-plugin
export default {"Box":"TimelineDivider-module__Box__IwTdJOY","Box_1":"TimelineDivider-module__Box_1__CvYbGNV","Box_2":"TimelineDivider-module__Box_2__KC4jTnq"};